_collow.components.Toasters = class Toasters extends (
    _collow.components.Base
) {
    root;
    toasterTemplate;
    availableTypes = ["success", "error", "info"];
    defaultOptions = {
        href: null,
        target: null,
        size: "default",
        showIcon: true,
        duration: 5000
    }

    constructor(root) {
        super();

        // Skip if already initialized
        if (_collow.Notify) {
            console.warn("Notifications already initialized.\nMultiple [data-component=\"Toasters\"] containers might be present.");
            return;
        };

        this.root = root;
        this._setToasterTemplate();
        this._createTypeFunctions();

        _collow.Notify = this;
    }

    /** Creates a toaster and adds it to the body 
     * @param {object} options
     * @param {string} options.message The message to display
     * @param {"success"|"error"|"info"} options.type The type of toaster to display
     * @param {string} options.href The link to redirect to when the action is clicked
     * @param {string} options.target The target for the action link
     * @param {string} options.actionLabel The label for the action button
     * @param {function} options.action callback function to run when the action is clicked
     * @param {"default"|"large"} options.size The size of the toaster
     * @param {boolean} options.showIcon Whether to display an icon or not
     * @param {number} options.duration The duration to show the toaster (in ms)
    */
    _create = (options) => {
        options = { ...this.defaultOptions, ...options };
        const toaster = new _collow.components.Toaster({
            ...options,
            template: this.toasterTemplate,
            closeToaster: this.closeToaster
        });

        this.showToaster(toaster, options.duration);
        return toaster;
    }

    showToaster = (toaster, duration = this.defaultOptions.duration) => {
        toaster.classList.add('fade-in');
        this.root.appendChild(toaster);

        setTimeout(() => {
            this.closeToaster(toaster);
        }, duration);
    }

    closeToaster = (toaster) => {
        toaster.classList.add('fade-out');
        setTimeout(() => {
            toaster.remove();
        }, 500);
    }

    /** Creates a function for each type of toaster */
    _createTypeFunctions() {
        this.availableTypes.forEach(type => {
            this[type] = (message, options) => this._create({ ...options, message, type });
        });
    }

    /** Gets the toaster template html and removes it from the DOM */
    _setToasterTemplate = () => {
        this.toasterTemplate = this.root.querySelector('.toaster');
        if (!this.toasterTemplate) throw new Error("Toaster template not found.");
        this.root.removeChild(this.toasterTemplate);
    }
}
